import { FormGroup } from "../../../components/form";
import * as Yup from "yup";

export const kindergartenOtherSearchForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "kindergarten",
      fieldType: "search",
      props: {
        apiPath: "Kindergarten/searchOther",
        placeholder: "If 'other kinder' search here",
        labelValue: "kindergartenNameOther",
        displayField: "kindergartenNameOther",
      },
      validation: Yup.object()
        // Need the test to check if the object is empty or not, because Yup.object().required() will always pass since an empty object is still an object
        // When Search is cleared, the values of the object are wiped (ref bug 53425)
        .test("Please enter a Kindergarten to search for", (value) => value != null && Object.values(value).some((item) => item != null))
        .required("Please enter a Kindergarten to search for"),
    },
    {
      type: "field",
      key: "year",
      fieldType: "input",
      props: {
        placeholder: "Year",
      },
      validation: Yup.string()
        .matches(RegExp(/^[0-9]{4}$/), {
          message: "Please enter a valid year for the search",
        })
        .required("Please enter a Year to search for"),
    },
    {
      type: "field",
      fieldType: "advisory",
      key: "advisory",
      props: {
        type: "fieldadv",
        styleClasses: "flex flex-col items-start",
        Body: () => (
          <div>
            <p>Enter both a Kindergarten and Year to check</p>
          </div>
        ),
      },
    },
  ],
};
